
import { printLocalDate } from "@/utils/pretty-print";
import Vue from "vue";
import { PdfS3UploadedFile } from "../models/pdf-archive-file";
import { PdfArchiveService } from "../services/pdf-archive-service";

export default Vue.extend({
	data() {
		return {
			item: null as null | PdfS3UploadedFile,
			dossierId: 0,
			userName: "",
			companyName: ""
		};
	},
	computed: {
		beginDate(): string {
			if (!this.item) return "";
			return printLocalDate(this.item.MinDate);
		},
		endDate(): string {
			if (!this.item) return "";
			return printLocalDate(this.item.MaxDate);
		}
	},
	methods: {
		async download() {
			console.log("ownload");
			if (!this.item) return;
			console.log("Downloading");
			await PdfArchiveService.downloadArchiveFromPublicUrl(this.dossierId, this.item);
		}
	},
	async mounted() {
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();

		this.dossierId = parseInt(this.$route.params.dossierId) || 0;
		let key = this.$route.params.key;
		let result = await PdfArchiveService.getArchiveFromPublicUrl(this.dossierId, key);
		this.item = result.fileInfo;
		this.userName = result.userName;
		this.companyName = result.companyName;
	},
	i18nEx: {componentPrefix: "views.PdfArchiveFromUrl"},
});
